import { BASE_URL } from "../config";
import { axiosInstance } from "../providers/AxiosProvider";

export function patchAdmin(body) {
  return axiosInstance.patch(`${BASE_URL}/api/users/admin`, body);
}

export function resetDatabase() {
  return axiosInstance.delete(`${BASE_URL}/api/reset-db`);
}
